import React, { useContext, useState } from "react";
import Grid from "../../Components/Grid";
import { Typography, styled, Box, Paper } from "@mui/material";
import GlobalContext from "../../Contexts/GlobalContext";
import isItMyTurn from "../../utils/isItMyTurn";
import StyledButton from "../../Components/StyledButton";
import QRCode from "react-qr-code";
import socket from "../../utils/socket";
import { useParams } from "react-router-dom";

const Text = styled(Typography)({
  position: "absolute",
  right: 100,
});

const AbsoluteBox = styled(Box)({
  position: "absolute",
});

const GamePage = () => {
  const { gameId } = useParams("");
  const { role, permanentDisable, checkersCount, gameStatus, winner } =
    useContext(GlobalContext);

  const [QRCodeVisibility, setQRCodeVisibility] = useState(false);
  const toggleQRCodeVisibility = () => setQRCodeVisibility(!QRCodeVisibility);

  const messageAccordingToRole = (role) => {
    if (role === "player1") return "Your Weapon: X";
    else if (role === "player2") return "Your Weapon: O";
    else return "You are spectating..";
  };

  const playAgain = () => {
    if (role === "spectator") return;
    socket.emit("play-again", gameId);
  };

  return (
    <div className="container">
      <Grid />
      <StyledButton
        onClick={toggleQRCodeVisibility}
        sx={{
          top: 10,
          right: 100,
          height: 35,
          borderBottom: "2px solid #335c67",
          borderRadius: 0,
        }}
      >
        {QRCodeVisibility ? "Hide QR Code" : "View QR Code"}
      </StyledButton>
      <AbsoluteBox
        sx={{
          display: QRCodeVisibility ? "block" : "none",
          zIndex: 99,
        }}
      >
        <QRCode bgColor="#9acef8" level="H" value={window.location.href} />
      </AbsoluteBox>

      <Paper
        elevation={5}
        sx={{
          height: 300,
          width: 300,
          display: gameStatus === "gameover" ? "block" : "none",
          background: "none",
          borderRadius: 5,
          position: "absolute",
          backdropFilter: "blur(5px)",
        }}
      >
        <Typography
          variant="h5"
          textAlign={"center"}
          sx={{ position: "relative", top: 10, color: "#610000" }}
        >
          Game Over.
        </Typography>
        <Typography
          variant="h6"
          textAlign={"center"}
          sx={{ position: "relative", top: 100, color: "#F5F5F5" }}
        >
          {!winner ? "No one won." : winner === role ? "You won!" : "You lost!"}
        </Typography>

        <StyledButton
          onClick={playAgain}
          sx={{
            top: 200,
            left: 90,
            color: "#610000",
            outline: "2px solid #610000",
            display: role === "spectator" ? "none" : "block",
          }}
        >
          Play Again
        </StyledButton>
      </Paper>
      <Text
        variant="h6"
        sx={{
          top: 55,
        }}
      >
        {gameStatus === "waiting"
          ? "Waiting for other player to join.."
          : messageAccordingToRole(role)}
      </Text>
      <Text
        variant="h6"
        sx={{
          top: 90,
          // Do not show if permanentDisable is active or if only one player is connected
          display:
            (permanentDisable ||
              gameStatus === "waiting" ||
              gameStatus === "gameover") &&
            "none",
        }}
      >
        {isItMyTurn(checkersCount, role) ? "Your turn" : "Wait for your turn"}
      </Text>
    </div>
  );
};

export default GamePage;
